import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postEmployeeKPI({ body }) {
  return BaseService.post(REST.EMPLOYEE_KPI, body);
}

function putEmployeeKPI({ body, id }) {
  return BaseService.put(REST.EMPLOYEE_KPI_ID(id), body);
}

function getEmployeeKPI(params) {
  return BaseService.get(REST.EMPLOYEE_KPI, {
    params: paramsFilter({ params }),
  });
}

function deleteEmployeeKPI({ id }) {
  return BaseService.delete(REST.EMPLOYEE_KPI_ID(id));
}

export default {
  postEmployeeKPI,
  putEmployeeKPI,
  getEmployeeKPI,
  deleteEmployeeKPI,
};
